<p>
  В платформата може да участвате в аукциони (обяви с наддаване), които ви дават възможност да закупите артикул
  на конкурентна цена чрез търг.
</p>
<h6 class="mt-3">Как да наддавате?</h6>
<ol>
  <li>Навигирайте до <strong>страницата на обявата</strong>, която е от вид „аукцион“.</li>
  <li>Натиснете бутона <strong>„Наддаване“</strong>, разположен под текущата цена.</li>
  <li>Ще се появи прозорец, в който да въведете <strong>максималната сума</strong>, която сте готови да предложите.</li>
  <li>Потвърдете наддаването чрез избрания от вас <strong>метод на потвърждение</strong> – ПИН код или парола.</li>
</ol>
<h6 class="mt-3">Какво представлява автоматичното наддаване?</h6>
<p class="mb-1">
  Системата на платформата използва <strong>автоматично наддаване</strong>. Това означава, че след като зададете
  максимална цена, тя няма да бъде предложена наведнъж. Вместо това, платформата ще наддава вместо вас, като:
</p>
<ul>
  <li>наддава с минималната възможна стъпка;</li>
  <li>поддържа ви като водещ участник в наддаването;</li>
  <li>не надвишава предварително зададената от вас максимална сума.</li>
</ul>
<h6>Пример:</h6>
<p>
  Ако текущата цена е <strong>50 лв.</strong>, минималната стъпка е <strong>1 лв.</strong>, и вие зададете <strong>максимална
  оферта от 70 лв.</strong>, а друг потребител въведе 55 лв., платформата автоматично ще предложи от ваше име 56 лв.
  Това ще продължи автоматично до достигане на вашия лимит (в случая 70 лв.), без да се налага да наддавате ръчно
  всеки път.
</p>
<h6 class="mt-3">Какво следва след спечелване?</h6>
<p class="mb-1">
  Ако спечелите аукциона, ще получите уведомление и платформата автоматично ще отвори <strong>чат между вас и
  продавача</strong>, където може да:
</p>
<ul>
  <li>Уточните детайли по <strong>доставката</strong> и <strong>плащането</strong>;</li>
  <li>Предоставите адрес за доставка или допълнителна информация;</li>
  <li>Получите потвърждение и проследите хода на изпращането.</li>
</ul>
<h6 class="mt-3">След приключване на сделката</h6>
<p>
  Ще имате възможност да оставите <strong>отзив</strong> за продавача. Това е важен елемент от изграждането на доверие
  между потребителите и спомага за по-добра оценка на търговската история на участниците в платформата.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Използвайте автоматичното наддаване, за да останете конкурентни, дори когато не сте пред
  устройството си.
</div>
